import React, { useState, useEffect } from 'react';
import { Dialog, DialogContent, Box, CircularProgress, IconButton } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';
import { Location } from '../types/Location';
import { LocationDetailsView } from './LocationDetailsView';

interface LocationPopUpDialogProps {
    locationId: string | null;
    open: boolean;
    onClose: () => void;
}

const LocationPopUpDialog: React.FC<LocationPopUpDialogProps> = ({ locationId, open, onClose }) => {
    const [location, setLocation] = useState<Location | null>(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!open || !locationId) {
            setLocation(null);
            return;
        }

        setLoading(true);
        const unsubscribe = onSnapshot(doc(db, 'locations', locationId), (docSnap) => {
            if (docSnap.exists()) {
                setLocation({ id: docSnap.id, ...docSnap.data() } as Location);
            } else {
                setLocation(null);
            }
            setLoading(false);
        });

        return () => unsubscribe();
    }, [locationId, open]);

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="lg"
            fullWidth
            scroll="body" // Scroll sur le body pour permettre de scroller toute la dialog
        >
            <Box sx={{ position: 'relative', bgcolor: 'background.default', minHeight: '50vh' }}>
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                        zIndex: 10
                    }}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent sx={{ p: { xs: 2, md: 4 } }}>
                    {loading ? (
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '300px' }}>
                            <CircularProgress />
                        </Box>
                    ) : location ? (
                        <LocationDetailsView location={location} />
                    ) : (
                        <Box sx={{ p: 3, textAlign: 'center' }}>
                            Chargement ou lieu introuvable...
                        </Box>
                    )}
                </DialogContent>
            </Box>
        </Dialog>
    );
};

export default LocationPopUpDialog;
